<!--
 * @Author: your name
 * @Date: 2021-09-06 21:08:56
 * @LastEditTime: 2022-03-27 13:33:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qklproject\src\App.vue
-->
<template>
  <div id="app">
    <bounty-header ref="bountyHeader"></bounty-header>
    <div class="routerBox" v-if="this.$route.path !== '/'">
      <router-link to="/skills">{{$t("Router.Skills")}}</router-link>
      <router-link to="/hotTask">{{$t("Router.HotTask")}}</router-link>
      <router-link to="/allTask">{{$t("Router.AllTask")}}</router-link>
      <router-link to="/projects">{{$t("Router.Projects")}}</router-link>
    </div>
    <router-view/>
    <!-- <bounty-footer v-if="this.$route.path !== '/'"></bounty-footer> -->
  </div>
</template>

<script>
import { Conflux } from 'js-conflux-sdk'
const cfx = new Conflux({ url: 'https://main.confluxrpc.com/', networkId: 1029, defaultGasPrice: 1000000, logger: console })
window.confluxJS = cfx
window.confluxJS.provider = window.conflux
export default {
  name: 'mainIndex',
  data () {
    return {}
  },
  mounted () {
    // if (window.conflux)
    console.log('this.$i18n.locale', this.$i18n.locale)
    console.log(this.$route.path)
  }
}
</script>
<style lang="scss">
@import '@/assets/css/gloabal.scss';
html, body {
  font-family: $fontFamilyCircularStd;
}
.avatar-uploader{
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #1C1C20;
  border-radius: 8px;
  cursor: pointer;
  img{
    width: 120px;
    height: 120px;
  }
  svg{
    margin-top: 16px;
    width: 60px;
    height: 60px;
  }
}
.load-more{
  display: inline-block;
  background: linear-gradient(96.34deg, #A737FF 0%, #18D6BE 100%);
  border-radius: 8px;
  cursor: pointer;
  margin-top: 26px;
  padding: 12px 32px;
  font-family: $fontFamilyCircularStd;
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
}
.el-textarea__inner,.el-input__inner,.el-range-input,.el-input-group__append,.el-form-item__content{
  background: #1C1C20 !important;
  font-family: $fontFamilyCircularStd !important;
  border-radius: 8px !important;
  color: #fff !important;
  border-color: #1C1C20 !important;
  &:focus{
    border-color: #1a796f !important;
    outline: 0;
  }
}
.el-form-item__label{
  line-height: 16px !important;
  padding-bottom: 12px !important;
  padding-top: 24px !important;
  font-family: $fontFamilyCircularStd !important;
  font-size: 16px !important;
  color: #CDCDCD !important;
}
#app {
  // font-family: Montserrat;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  position: relative;
  height: 100vh;
}
.no-data{
  font-size: 16px;
  font-family: $fontFamilyCircularStd;
  font-style: normal;
  font-weight: normal;
}
.routerBox {
  position: fixed;
  top: 0;
  left: 335px;
  display: flex;
  z-index: 9;
  align-items: center;
  border-radius: 12px;
  margin-right: 4px;
  // background: #1C1C20;
  a {
    color: #fff;
    font-family: $fontFamilyCircularStd;
    font-style: normal;
    font-size: 18px;
    line-height: 23px;
    padding-top: 45px;
    padding-left: 20px;
    padding-right: 20px;
    &.router-link-exact-active {
      background: url('./assets/My/hover.png') no-repeat top center;
      background-size: 100% 6px;
      color: #18D6BE;
      // font-weight: bold;
    }
  }
}
.el-tooltip__popper.is-dark{
  width: 260px !important;
  color: #bbb !important;
  background-color: #35353D !important;
  font-family: $fontFamilyCircularStd;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 14px !important;
  line-height: 18px !important;
  padding: 12px !important;
  border-radius: 12px !important;
}
// #nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//
//   }
// }
</style>
